<div class="cta-section">
  <div class="cta-card">
    <div class="cta-glow" aria-hidden="true"></div>

    <h2 class="cta-heading">
      <span class="cta-heading--dark">Grow</span>
      <span class="cta-heading--teal">your pipeline</span>
    </h2>

    <a routerLink="/product" class="cta-btn">Get started — it's free</a>

    <div class="cta-divider" aria-hidden="true"></div>

    <div class="cta-quote-strip">
      <div class="cta-author-avatar">JD</div>
      <p class="cta-quote-text">
        <span class="cta-quote-mark">&#8220;</span>Placeholder testimonial quote — real customer feedback to be added later.
      </p>
      <div class="cta-author-info">
        <span class="cta-author-name">Placeholder Name</span>
        <span class="cta-author-role">Placeholder Role, Company</span>
      </div>
    </div>
  </div>
</div>
